// extracted by mini-css-extract-plugin
module.exports = {"customModal":"AdvDialogModal_customModal__YRq9L"};